import './transfer-comment.ajscss';

import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './transfer-comment.html';

const MODULE_NAME = 'transferComment';

class TransferCommentCtrl implements IComponentController {
  public name = MODULE_NAME;

  // binding
  public eventCommentChange: Function;

  // internal properties
  public comment: string;

  $onInit() {}

  onTargetChange(): void {
    this.eventCommentChange({ $event: { comment: this.comment } });
  }
}

export class TransferComment implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    eventCommentChange: '&',
  };
  controller = [TransferCommentCtrl];
}

export default MODULE_NAME;
